// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";

import { Stack, useMediaQuery, useTheme, TextField, Autocomplete, LinearProgress } from "@mui/material";
import BaseFilterTableWithAccordion from "../../atoms/BaseFilterTableWithAccordion";
import {
  GridColDef,
  GridRowId,
  GridRenderCellParams,
  GridPaginationModel,
} from "@mui/x-data-grid";
import { Table } from "../../molecules";
import { Button } from "../../atoms";
import {
  DeleteMerchantRequest,
  IMerchant,
  PagingResponse,
  useAuthorization,
  useGetGMUStoreDevices,
  useUpdateGMUStoreDevice,
  IGMUStoreDevice,
  useGetMerchantsWithParentMerchant
} from "../../../hooks";
import { useNavigate } from "react-router-dom";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { downloadExcel } from "../../../util/downloadExcel";
import { RequestFilterOperationTypeEnum, RequestFilterValueTypeEnums } from "../../../common/enums/RequestFilterEnums";



export const TerminalDevice = ({ merchantId }: { merchantId?: number }) => {
  const theme = useTheme();
  const { showDelete, showUpdate } = useAuthorization();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const [queryOptions, setQueryOptions] = React.useState({});
  const [tableData, setTableData] = useState<PagingResponse<Array<IGMUStoreDevice>>>();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const [isFilterAccordionExpanded, setFilterAccordionExpand] = useState(true);
  const [showTable, setShowTable] = useState(false)
  const navigate = useNavigate();
  const { mutate: getGMUStoreDevices, isLoading } = useGetGMUStoreDevices();
  const { mutate: updateGMUStoreDevice, isLoading: isUpdating } = useUpdateGMUStoreDevice();
  const setSnackbar = useSetSnackBar();
  const [shouldRefresh, setShouldRefresh] = React.useState(0);

  const [selectedMerchant, setSelectedMerchant] = useState<{ label: string; value: number } | null>(null);
  const { data: rawMerchantList } = useGetMerchantsWithParentMerchant("ACTIVE");

  const merchantList = useMemo(() => {
    return rawMerchantList?.data?.map(
      (rawPosType: { merchantName: string; merchantId: number }) => {
        return {
          label: `${rawPosType.merchantName} (${rawPosType.merchantId})`,
          value: rawPosType.merchantId,
        };
      }
    );
  }, [rawMerchantList?.data]);

  useEffect(() => {
    if (merchantId && merchantList) {
      const found = merchantList.find((m) => m.value === merchantId);
      if (found) {
        setSelectedMerchant(found);
      }
    }
  }, [merchantId, merchantList]);

  useEffect(() => {
    const requestPayload = {
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
      orderByDesc: true,
      status: null,
      filters: [],
      ...getQueryParams(queryOptions),
    };

    if (selectedMerchant?.value) {
      requestPayload.filters.push({
        field: "merchantId",
        values: [selectedMerchant.value.toString()],
        operationType: RequestFilterOperationTypeEnum.EQUALS,
        valueType: RequestFilterValueTypeEnums.STRING
      });
    }

    getGMUStoreDevices(
      requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            const dataWithIds = {
              ...data.data,
              result: data.data?.result?.map((item, index) => ({
                ...item,
                id: item.id || index + 1
              })) || []
            };
            setTableData(dataWithIds);
            if (!data?.data?.result || data?.data?.result.length === 0) {
              setSnackbar({
                severity: "info",
                description: "Belirtilen kriterlere uygun veri bulunamadı",
                isOpen: true,
              });
            }
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  }, [
    getGMUStoreDevices,
    paginationModel.page,
    paginationModel.pageSize,
    setSnackbar,
    queryOptions,
    shouldRefresh,
    selectedMerchant,
  ]
  );

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    setTableData(undefined);

    const requestPayload = {
      size: model.pageSize,
      page: model.page,
      orderBy: "CreateDate",
      orderByDesc: true,
      status: null,
      filters: [],
      ...getQueryParams(queryOptions),
    };

    if (selectedMerchant?.value) {
      requestPayload.filters.push({
        field: "merchantId",
        values: [selectedMerchant.value],
        operationType: RequestFilterOperationTypeEnum.EQUALS,
        valueType: RequestFilterValueTypeEnums.STRING
      });
    }

    getGMUStoreDevices(
      requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            const dataWithIds = {
              ...data.data,
              result: data.data?.result?.map((item, index) => ({
                ...item,
                id: item.id || (model.page * model.pageSize) + index + 1
              })) || []
            };
            setTableData(dataWithIds);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  const UpdateButton = ({ gmuDeviceId, isActiveOnGMU, disabled, name }) => {
    const handleUpdate = () => {
      updateGMUStoreDevice(
        {
          gMUDeviceId: gmuDeviceId,
          isActiveOnGMU: !isActiveOnGMU
        },
        {
          onSuccess: (data) => {
            if (data.isSuccess) {
              setSnackbar({
                severity: 'success',
                description: data.message || 'İşlem başarılı.',
                isOpen: true,
              });
              setShouldRefresh(prev => prev + 1);
            } else {
              setSnackbar({
                severity: 'error',
                description: data.message,
                isOpen: true,
              });
            }
          },
          onError: () => {
            setSnackbar({
              severity: 'error',
              description: 'İşlem sırasında bir hata oluştu.',
              isOpen: true,
            });
          },
        }
      );
    };

    return (
      <Button
        text={name}
        variant="text"
        color="info"
        sx={{ flex: 1, height: 20, py: 5 }}
        disabled={disabled}
        onClick={handleUpdate}>
      </Button>
    );
  };

  const columns: GridColDef[] = useMemo(() => {
    return [
      { field: "username", headerName: "Kullanıcı", width: 200 },
      { field: "merchantName", headerName: "İşyeri Adı", width: 200 },
      { field: "gmuDeviceId", headerName: "GMU Cihaz ID", width: 200 },
      { field: "deviceSerialNumber", headerName: "Cihaz Seri Numarası", width: 200 },
      { field: "brand", headerName: "Marka", width: 200 },
      { field: "model", headerName: "Model", width: 200 },
      {
        field: "isActiveOnGMU", headerName: "GMU Aktif", width: 200,
        renderCell: (params: GridRenderCellParams) => (
          params.value ? "Evet" : "Hayır"
        )
      },
      {
        field: "updateButton",
        headerName: "İşlemler",
        width: 150,
        sortable: false,
        filterable: false,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <UpdateButton
              gmuDeviceId={params.row.gmuDeviceId}
              isActiveOnGMU={params.row.isActiveOnGMU}
              disabled={isUpdating}
              name={params.row.isActiveOnGMU ? "Devre Dışı Bırak" : "Etkinleştir"}
            />
          );
        },
      },
    ];
  }, [isUpdating]);

  const onSave = () => {
    const requestPayload = {
      size: -1,
      page: 0,
      orderBy: "CreateDate",
      orderByDesc: true,
      status: null,
      filters: [],
      ...getQueryParams(queryOptions),
    };

    if (selectedMerchant?.value) {
      requestPayload.filters.push({
        field: "merchantId",
        values: [selectedMerchant.value],
        operationType: RequestFilterOperationTypeEnum.EQUALS,
        valueType: RequestFilterValueTypeEnums.STRING
      });
    }

    getGMUStoreDevices(
      requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            const refactoredData = data?.data?.result?.map((item) => ({
              "Id": item.id,
              "Kullanıcı": item.username,
              "İşyeri Adı": item.merchantName,
              "GMU Cihaz ID": item.gmuDeviceId,
              "Cihaz Seri Numarası": item.deviceSerialNumber,
              "Marka": item.brand,
              "Model": item.model,
              "GMU Aktif": item.isActiveOnGMU ? "Evet" : "Hayır"
            }));
            downloadExcel(refactoredData || [], "Terminal Cihazları Listesi", null);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      if (filters[key]?.toString()?.length >= 1) {
        queryParams[key] = filters[key];
      }
    }

    return queryParams;
  };

  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
  const hasLoading = isLoading || isUpdating;

  return (
    <>
      {hasLoading && <LinearProgress sx={{ height: 2 }} />}
      <Stack flex={1} p={2} >
        {!merchantId && (
          <div style={{ marginBottom: '16px' }}>
            <Autocomplete
              id="merchantId"
              options={merchantList || []}
              getOptionLabel={(option) => option.label}
              value={selectedMerchant}
              onChange={(_, newValue) => {
                setSelectedMerchant(newValue);
              }}
              renderInput={(params) => (
                <TextField {...params} label="İşyeri" />
              )}
            />
          </div>
        )}
        <Table
          columnVisibilityConfigKey="TerminalDeviceTableColumnVisibilityKey"
          filterKey="TerminalDeviceTableFilter"
          hasActiveFilters={hasActiveFilters}
          paginationModel={paginationModel}
          onPaginationModelChange={handleChangePagination}
          paginationMode="server"
          rowCount={tableData?.totalItems || 0}
          sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
          rows={tableData?.result ?? []}
          columns={columns}
          exportFileName="Terminal Cihazları Listesi"
          onSave={() => onSave()}
          disableColumnFilter={false}
        />
      </Stack>
    </>
  );
};
